import { Skeleton } from '@mui/material';

import './styles.scss';

/**
 * Card-shaped placeholder — same radius as the `Card` fragment so the grid keeps
 * its rhythm while data loads.
 */
export function CardSkeleton({ height = 160, className = '' }) {
    return (
        <Skeleton
            variant="rounded"
            height={height}
            animation="wave"
            className={`home-skeleton home-skeleton--card ${className}`.trim()}
        />
    );
}

/**
 * List-row placeholders for the flush list cards: a round chip, two text bars
 * and a trailing value — mirroring the real row anatomy.
 */
export function RowsSkeleton({ rows = 4 }) {
    return (
        <ul className="home-skeleton-rows" aria-hidden="true">
            {Array.from({ length: rows }).map((_, i) => (
                <li key={i} className="home-skeleton-rows__row">
                    <Skeleton variant="circular" width={36} height={36} animation="wave" className="home-skeleton" />
                    <div className="home-skeleton-rows__text">
                        <Skeleton variant="text" width="55%" height={16} animation="wave" className="home-skeleton" />
                        <Skeleton variant="text" width="35%" height={12} animation="wave" className="home-skeleton" />
                    </div>
                    <Skeleton variant="text" width={56} height={16} animation="wave" className="home-skeleton" />
                </li>
            ))}
        </ul>
    );
}
